import './index.html';
import './style.scss';
import {imageLazyLoading} from "../../scripts/functions/imageLazyLoading";
import {animations} from "../../scripts/general/animations";
import {gsap} from "gsap";
import {debounce} from "lodash";


export default async (footer = document) => {
  const media = window.matchMedia('(max-width: 599px)');

  // const accordions = footer.querySelectorAll('.footer-links')
  // accordions.forEach((accordion) => {
  //   const accordionHead = accordion.querySelector('.links-title');
  //   const accordionBody = accordion.querySelector('.links-wrapper');
  //   accordionHead?.addEventListener('click', (e) => {
  //     if (media.matches) {
  //       if (!accordionBody) return;
  //       const isOpened = accordion?.classList.toggle('active');
  //       if (!isOpened) {
  //         gsap.to(accordionBody, {height: 0});
  //       } else {
  //         gsap.to(Array.from(accordions).map(otherFaq => {
  //           const otherFaqBody = otherFaq.querySelector('.links-wrapper');
  //           if (otherFaqBody && accordion !== otherFaq) {
  //             otherFaq?.classList.remove('active');
  //             gsap.set(otherFaq, {zIndex: 1});
  //           }
  //           return otherFaqBody;
  //         }), {height: 0});
  //         gsap.set(accordion, {zIndex: 2});
  //         gsap.to(accordionBody, {height: 'auto'});
  //       }
  //     }
  //   });
  // });

  animations(footer);
  imageLazyLoading(footer);
};

